<template>
  <div ref="componentContainer" v-resize="setContainerWidth">
    <v-card
      :elevation="!showBackgroundElevation || !showBackground ? 0 : 2"
      class="backgroundImage ma-0 pa-0"
      :style="
        `
            background-color: rgba(0,0,0,0);
            background-image:url('${showBackground ? backgroundImageURL : ''}'); 
            `
      "
      style=" border-radius: 0px !important;"
    >
      <v-container class="ma-0 pa-0">
        <v-row justify="center" :style="`height: ${businessCardCoverHeight * 0.35}px;`"> </v-row>
        <v-row justify="center" no-gutters>
          <v-col :cols="isWide ? 8 : 11">
            <div class="scene">
              <div class="card" :class="{ flipped: businessCardSide != 'front' }">
                <div
                  class="card__face card__face--front"
                  @click="hideToggleControl ? null : (businessCardSide = 'back')"
                  :style="!hideToggleControl ? 'cursor: pointer;' : ''"
                >
                  <BusinessCardFront
                    :isInRotator="true"
                    :logoFrame="logoFrame"
                    :cardCorners="cardCorners"
                    :logoImageURL="logoImageURL"
                    :title="title"
                    :subtitle="subtitle"
                    :line1="line1"
                    :line2="line2"
                    :line3="line3"
                    :qualification="qualification"
                  />
                </div>
                <div
                  class="card__face card__face--back"
                  @click="hideToggleControl ? null : (businessCardSide = 'front')"
                  :style="!hideToggleControl ? 'cursor: pointer;' : ''"
                >
                  <BusinessCardBack
                    :cardCorners="cardCorners"
                    :reverseImageURL="reverseImageURL"
                    :reverseCardLink="reverseCardLink"
                  />
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row justify="center" :style="`height: ${businessCardCoverHeight * 0.65}px;`"> </v-row>
      </v-container>
    </v-card>
    <v-row
      justify="center"
      no-gutters
      :style="`height: ${isWide ? businessCardCoverHeight * 0.24 : businessCardCoverHeight * 0.32}px;`"
    >
    </v-row>
    <v-row justify="center" no-gutters>
      <v-col cols="12">
        <v-card color="transparent" flat>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="!hideToggleControl" style="display: flex;justify-content: center;">
              <div
                :class="{ primary: businessCardSide == 'front' }"
                :style="
                  `height: ${dotDiameter}px; width: ${dotDiameter}px;border-radius: 50%;margin-right: ${dotDiameter /
                    2}px; background-color: rgba( 241, 95, 49, 0.24); cursor: pointer;`
                "
                @click="hideToggleControl ? null : (businessCardSide = 'front')"
              ></div>
              <div
                :class="{ primary: businessCardSide == 'back' }"
                :style="
                  `height: ${dotDiameter}px; width: ${dotDiameter}px;border-radius: 50%;margin-left: ${dotDiameter /
                    2}px; background-color: rgba( 241, 95, 49, 0.24); cursor: pointer;`
                "
                @click="hideToggleControl ? null : (businessCardSide = 'back')"
              ></div>
            </div>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import BusinessCardFront from "./BusinessCardFront";
import BusinessCardBack from "./BusinessCardBack";
export default {
  name: "BusinessCardRotator",
  props: {
    logoImageURL: {
      type: String,
      default: "",
    },
    reverseImageURL: {
      type: String,
      default: "",
    },
    backgroundImageURL: {
      type: String,
      default: "",
    },
    logoFrame: {
      type: String,
    },
    cardCorners: {
      type: String,
    },
    hideToggleControl: {
      type: Boolean,
      default: false,
    },
    businessCardSideProp: {
      type: Number,
      default: 0,
    },
    showBackgroundElevation: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    line1: {
      type: String,
      default: "",
    },
    line2: {
      type: String,
      default: "",
    },
    line3: {
      type: String,
      default: "",
    },
    animatedEntry: {
      type: Boolean,
      default: false,
    },
    showBackground: {
      type: Boolean,
      default: true,
    },
    reverseCardLink: {
      type: String,
      default: "",
    },
    qualification: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      businessCardSide: "front",
      x: 0,
    };
  },
  computed: {
    businessCardCoverHeight() {
      let aspectRatio = 250 / 378;
      return this.isWide ? this.x * aspectRatio * 0.8 : this.x * aspectRatio;
    },
    dotDiameter() {
      return this.x * 0.018;
    },
    isWide() {
      return this.x > 330;
    },
  },
  watch: {
    businessCardSideProp: function(newVal, oldVal) {
      if (newVal != null) {
        this.businessCardSide = newVal % 2 == 0 ? "front" : "back";
      }
    },
  },
  components: {
    BusinessCardFront,
    BusinessCardBack,
  },
  methods: {
    setContainerWidth() {
      if (this.$refs.componentContainer != null) this.x = this.$refs.componentContainer.clientWidth;
    },
  },

  data() {
    return {
      businessCardSide: "front",
      x: 0,
    };
  },
  created() {
    this.businessCardSide = this.businessCardSideProp % 2 == 0 ? "front" : "back";
    if (this.animatedEntry) {
      this.businessCardSide = "back";
      setTimeout(() => {
        this.businessCardSide = "front";
      }, 800);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setContainerWidth();
    });
  },
};
</script>
<style scoped>
.v-sheet.v-card {
  border-radius: 0px;
}

.scene {
  perspective: 700px;
}

.card {
  width: 100%;
  height: 100%;
  position: relative;
  transition: transform 0.6s ease;
  transform-style: preserve-3d;
}
.card__face {
  position: absolute;
  height: 100%;
  width: 100%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}
.card__face--back {
  transform: rotateY(180deg);
}
.card.flipped {
  transform: rotateY(180deg);
}
.backgroundImage {
  /* Full height */
  height: 100%;
  /* Center and scale the image properly */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
